export default __webpack_public_path__ + "static/media/CalendarIcon.0c428dd9.svg";